module.exports = __webpack_public_path__ + "static/old-mailbox-a7fb890ddee5fda866a63acd9f27bf6f.jpg";